// extracted by mini-css-extract-plugin
export var alternate = "_8-j";
export var black = "_8-6";
export var blue = "_8-f";
export var blueLight = "_8-e";
export var brand = "_8-8";
export var darkMode = "_8-b";
export var error = "_8-a";
export var gray = "_8-5";
export var grayBlue = "_8-d";
export var iconWrapper = "_8-3";
export var inactive = "_8-7";
export var indigo = "_8-g";
export var orange = "_8-i";
export var pink = "_8-h";
export var primary = "_8-0";
export var purple = "_8-9";
export var success = "_8-4";
export var warning = "_8-c";
export var white = "_8-1";
export var whiteSuccess = "_8-2";